import { Cookies } from 'react-cookie'
import getEnv from './getEnv'

const cookies = new Cookies()

// Self-host serves every tenant from one origin under /app/:subDomain
// (path-based tenancy) — an auth cookie set at the default root path would
// be sent on every other tenant's path on that same origin too. Scope it to
// this tenant's own path prefix instead, so two locations opened on the
// same origin (in separate tabs, or one after another) never see each
// other's session cookie. REACT_APP_APP_PATH is the same value the router's
// basename already uses (see index.tsx) — the server computes it once per
// tenant (server/lib/pos.ts's renderConfigJs) and this just reuses it,
// rather than re-deriving "/app/<subdomain>" independently here. Cloud never
// sets it, so this stays the root path there — unchanged from today.
export const scopedCookiePath = (): string => {
    return getEnv('REACT_APP_APP_PATH') || '/'
}

export default cookies
